import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import * as _ from 'lodash';

import { AutoUnsubscribe, AvailableLanguage, getAppExternalLink, getAppLogo, getAppName } from 'helpers';
import { LanguageService } from 'services';
import { ImageModel } from 'shared/models';

@AutoUnsubscribe
@Component({
    selector: 'fc-referral',
    templateUrl: './referral-signup.component.html',
    styleUrls: ['./referral-signup.component.less'],
    standalone: false
})
export class ReferralSignupComponent implements OnInit {
    languageForm: FormGroup;
    languages = [];
    appInfo: {
        logo: {
            small: string;
            medium: string;
            original: string;
            smallWhite: string;
        };
        name: string;
        link: string;
    };
    referralBrandLogoUrl$: Observable<string>;
    displayReferralBrandInfo$: Observable<boolean>;

    private _referralId$: Observable<string>;
    private _step$: Observable<number>;

    constructor(
        private languageService: LanguageService,
        private formBuilder: FormBuilder,
        private imageModel: ImageModel,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this._referralId$ = combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
            map(([params, queryParamMap]) => {
                return params.get('referralId') || queryParamMap.get('referralId');
            })
        );

        this._step$ = this.route.queryParamMap.pipe(map((params) => +params.get('step') || 0));

        this.displayReferralBrandInfo$ = this.route.url.pipe(
            withLatestFrom(this._step$),
            map(([urlSegments, step]) => {
                const paths = urlSegments.map((segment) => segment.path);
                return paths.includes('verify-email') ? true : step === 0;
            })
        );

        this.referralBrandLogoUrl$ = this._referralId$.pipe(
            map((referralId) => this.imageModel.buildReferralBrandLogoUrl(referralId))
        );

        this.appInfo = {
            logo: getAppLogo(),
            name: getAppName(),
            link: getAppExternalLink()
        };

        const browserLanguage = this.languageService.getBrowserLanguage();
        this.languageForm = this.formBuilder.group({
            lang: { label: _.upperCase(browserLanguage), value: browserLanguage }
        });

        this.initLanguages();
    }

    private initLanguages() {
        const languageKeys = _.keys(AvailableLanguage);
        languageKeys.forEach((language) => {
            this.languages.push({
                label: _.upperCase(language),
                value: AvailableLanguage[language],
                action: () => {
                    this.languageService.use(AvailableLanguage[language]);
                    this.languageForm.patchValue({
                        lang: { label: _.upperCase(AvailableLanguage[language]), value: AvailableLanguage[language] }
                    });
                }
            });
        });
    }
}
